import { CONSTANTS } from "utilities/constants";

const brand = process.env.REACT_APP_BRAND;
const redirectUri =
  typeof window !== "undefined" ? window.location.origin + "/login/callback" : ""; // or some fallback or throw

const oktaAuthConfig = {
    language: "en",
    i18n: {
        "en": {
            "primaryauth.title": "Sign in",
            "primaryauth.submit": "Sign in"
        }
    },
    features: {
        rememberMe: true,
        selfServiceUnlock: false,
        router: false
    },
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: redirectUri,
    responseType: "code",
    responseMode: "query",
    pkce: true,
    scopes: ["openid", "email", "profile", "brand:" + brand]
};

export { oktaAuthConfig };
